import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { User } from '../models/usermodel';
import { UserUpdate } from '../models/userupdatemodel';
import { AcctResponse } from '../models/accountresponse';
import { Observable } from 'rxjs/Rx';
import { config } from '../config/config';
import { SharedService } from './sharedservices.service';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class userService {
  usersUrl: string = config.baseUrl + "user";
  url: string = config.baseUrl + "user";
  updateurl: string = config.baseUrl + "user";
  //authconfig: string = config.username + ':' + config.password;

  constructor(private http: Http, private sharedservice: SharedService) { }

  /*createAuthorizationHeader(headers: Headers) {
    let conversionSessionOutput = CryptoJS.AES.decrypt(localStorage.getItem("access_token"), config.key).toString(CryptoJS.enc.Utf8);
    let authconfig = this.sharedservice.session.account_username + ':' + conversionSessionOutput;
    headers.append('Authorization', 'Basic ' +
      btoa(authconfig));
  }*/

  getUsers(): Observable<User[]> {
    const headers = new Headers();
    // this.createAuthorizationHeader(headers);
    return this.http.get(this.usersUrl, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }



  postUser(user: User): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(user);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.url, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }


  updateUser(user: UserUpdate): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(user);
    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.put(this.updateurl, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }


  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    //console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/user.service.ts